import Vue, { VNode } from "vue";
export interface VNodeDirective {
  name: string;
  value?: any;
  oldValue?: any;
  expression?: any;
  arg?: string;
  oldArg?: string;
  modifiers?: { [key: string]: boolean };
}

interface ObserveVNodeDirective extends VNode {
  name: string;
  value?: any;
  oldValue?: any;
  expression?: any;
  arg?: string;
  oldArg?: string;
  modifiers?: { [key: string]: boolean };
  options?: IntersectionObserverInit;
}

interface IntersectObserveElement extends HTMLElement {
  _observe?: {
    init: boolean;
    observer: IntersectionObserver;
  };
}

export const VZIntersect = {
  mounted(el: any, binding: any) {
    const modifiers = binding?.modifiers || {};

    const value = binding.value;
    const isObject = typeof value === "object";
    const callback = isObject ? value.handler : value;

    const observerInstance = new IntersectionObserver(
      (
        entries: IntersectionObserverEntry[],
        observer: IntersectionObserver
      ) => {
        if (!el._observe) {
          return;
        }

        if (callback && (!modifiers.quiet || el._observe.init)) {
          const isIntersecting = Boolean(
            entries.find((entry) => entry.isIntersecting)
          );
          callback(entries, observer, isIntersecting);
        }

        if (el._observe.init && modifiers.once) {
          this.unmounted(el);
        } else {
          el._observe.init = true;
        }
      },
      value ? value.options || {} : {}
    );

    el._observe = {
      init: false,
      observer: observerInstance,
    };

    observerInstance.observe(el);
  },

  unmounted(el: any) {
    if (!el._observe) {
      return;
    }

    el._observe.observer.unobserve(el);
    delete el._observe;
  },
};
